// Cookie对象
import Cookie from 'js-cookie';
// 站点配置
import config from 'config/Config';

// 删除Cookie
const clearCookie = () => {
  if(!config.cookie){
    return false;
  }
  Object.keys(config.cookie).map((key, idx) => {
    Cookie.remove(config.cookie[key]);
  })
  return true;
}
const clearAllCookie = () => {
  	for (let i in Cookie.get()) {
		Cookie.remove(i)
  	}
}

export { clearCookie, clearAllCookie }


// WEBPACK FOOTER //
// ./src/utils/store.js